$(function () {
  var customer = getShoptetDataLayer('customer');

  

  var invoiceFields = ['billStreet', 'billHouseNumber', 'billCity', 'billZip', 'billCountryId'];
  var storageKey = 'selected-shipping-id-' + window.location.hostname.replace(/^www\./, '');
  var $body = $('body');
  var $billing = $('.co-billing-address');
  var $contact = $('.co-contact-information');

  function getStoredShippingId() {
    var val = localStorage.getItem(storageKey);
    return val ? parseInt(val, 10) : null;
  }

  function cleanLabelText($label) {
    return $.trim($label.text().replace('*', ''));
  }

  function disableInvoiceValidation() {
    $.each(invoiceFields, function (i, fieldId) {
      var $input = $('#' + fieldId);
      var $label = $('[for="' + fieldId + '"]');

      $input
        .closest('.form-group')
        .removeClass('js-validated-element-wrapper');

      $input
        .removeAttr('required')
        .removeClass('required js-validate js-validate-required');

      if ($label.length) {
        $label.html(cleanLabelText($label));
      }
    });
  }

  function highlightRequiredFields() {
    $.each(invoiceFields, function (i, fieldId) {
      var $input = $('#' + fieldId);
      var $label = $('[for="' + fieldId + '"]');

      $input
        .attr('required', true)
        .addClass('required js-validate js-validate-required');

      $input
        .closest('.form-group')
        .addClass('js-validated-element-wrapper');

      if ($label.length) {
        var labelText = cleanLabelText($label);
        $label.html('<span class="required-asterisk">' + labelText + '</span>');
      }
    });
  }

  function insertInvoiceCheckbox() {
    if ($('#toggle-invoice').length) {
      return;
    }

    var html = `
      <div class="form-group toggle-invoice-wrapper">
        <input type="checkbox" id="toggle-invoice">
        <label for="toggle-invoice" class="whole-width">${translation('fakturacni')}</label>
      </div>
    `;

    $contact.append(html);
  }

  function bindCheckboxToggle() {
    $(document).off('change.toggleInvoice').on('change.toggleInvoice', '#toggle-invoice', function () {
      if ($(this).is(':checked')) {
        $billing
          .addClass('visible')
          .removeClass('js-hidden');

        highlightRequiredFields();
      } else {
        $billing
          .removeClass('visible')
          .addClass('js-hidden');

        disableInvoiceValidation();
      }
    });
  }

  function shouldDisableInvoiceByShipping() {
    var shippingId = getStoredShippingId();

    if (!shippingId) {
      return false;
    }

    return $.inArray(shippingId, allowedShippingIds) > -1;
  }

  // Krok 1 - uložení zvolené dopravy
  if ($body.hasClass('id--16')) {
    $(document).on('click', '#orderFormButton', function () {
      var selectedId = $('[name="shippingId"]:checked').val();

      if (selectedId) {
        localStorage.setItem(storageKey, selectedId);
      }
    });
  }

  // Krok 2 - fakturační údaje
  if ($body.hasClass('id--17')) {
    // Výchozí stav vždy zpovinní fakturační pole
    // platí pro přihlášeného i nepřihlášeného zákazníka
    highlightRequiredFields();

    // Znepovinní pouze pro povolené dopravy
    if (shouldDisableInvoiceByShipping()) {
      disableInvoiceValidation();

      $billing
        .addClass('js-hidden')
        .removeClass('visible');

      insertInvoiceCheckbox();
      bindCheckboxToggle();
    } else {
      $billing
        .removeClass('js-hidden')
        .addClass('visible');

      highlightRequiredFields();
    }
  }
});